<div class="content-wrapper container-xxl p-0">
  <app-content-header [contentHeader]="contentHeader"></app-content-header>
  <div class="form-row">
    <div class="form-group col-md-6">
      <label>{{ "COMMISSIONS.NAME_OR_EMPLOYEE" | translate }}</label>
      <input [(ngModel)]="commissionNameOrEmployeeName" class="form-control" (ngModelChange)="filter()" />
    </div>
    <div class="form-group col-md-6">
      <label>{{ "CUSTOMER" | translate }}</label>
      <ng-select [clearable]="clientIdSelected > 0" [(ngModel)]="clientIdSelected" (ngModelChange)="filter()" (clear)="clientIdSelected = 0" [openOnEnter]="true" [closeOnSelect]="true" [searchable]="true">
        <ng-option [value]="0">{{ "ALL" | translate }}</ng-option>
        <ng-option *ngFor="let customer of customers" [value]="customer?.id">
          {{ customer?.name }}
        </ng-option>
      </ng-select>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-md-3">
      <label>{{ "COMMISSION" | translate }}</label>
      <select [(ngModel)]="commissionIdSelected" class="form-control" id="commission" (change)="filter()">
        <option [value]="0">{{ "ALL_FEMALE_PLURAL" | translate }}</option>
        <option *ngFor="let commission of selectCommissions" [value]="commission?.id">
          {{ commission?.complete_name }}
        </option>
      </select>
    </div>
    <div class="form-group col-md-3">
      <label for="status">{{ "STATE" | translate }}</label>
      <select [(ngModel)]="status" class="form-control" id="status" (change)="filter()">
        <option [value]="0">{{ "OPENED_FEMALE" | translate }}</option>
        <option [value]="1">{{ "CLOSED_FEMALE" | translate }}</option>
      </select>
    </div>
    <div class="form-group col-md-5 d-flex align-items-center">
      <div class="mr-075">
        <label>{{ "FROM" | translate }}</label>
        <div>
          <label for="startMonth" class="mb-0" [ngClass.sm]="'flex-basis-66'" [ngClass.md]="'flex-basis-66'">
            <select [(ngModel)]="selectedStartMonth" id="startMonth" class="form-control pr-3 text-capitalize">
              <option selected disabled value="all">{{ "MONTH" | translate }}</option>
              <option *ngFor="let month of availableMonths" [value]="month" [label]="formatMonth(month)">{{ month }}</option>
            </select>
          </label>
          <label for="starYear" class="mb-0 ml-1" [ngClass.sm]="'flex-basis-33'" [ngClass.md]="'flex-basis-33'">
            <select id="starYear" [(ngModel)]="selectedStartYear" class="form-control pr-3">
              <option *ngFor="let year of availableYears" [value]="year">{{ year }}</option>
            </select>
          </label>
        </div>
      </div>
      <div>
        <label>{{ "TO" | translate }}</label>
        <div>
          <label for="endMonth" class="mb-0" [ngClass.sm]="'flex-basis-66'" [ngClass.md]="'flex-basis-66'">
            <select [(ngModel)]="selectedEndMonth" id="endMonth" class="form-control pr-3 text-capitalize">
              <option selected disabled value="all">{{ "MONTH" | translate }}</option>
              <option *ngFor="let month of availableMonths" [value]="month" [label]="formatMonth(month)">{{ month }}</option>
            </select>
          </label>
          <label for="endYear" class="mb-0 ml-1" [ngClass.sm]="'flex-basis-33'" [ngClass.md]="'flex-basis-33'">
            <select id="endYear" [(ngModel)]="selectedEndYear" class="form-control pr-3">
              <option *ngFor="let year of availableYears" [value]="year">{{ year }}</option>
            </select>
          </label>
        </div>
      </div>
    </div>
    <div class="form-group col-md-1 text-right">
      <button class="btn btn-primary position-relative" style="top: 1.7rem;" (click)="loadStat()">{{ 'SEARCH' | translate }}</button>
    </div>
  </div>
  <div class="form-row justify-content-end">
    <div class="form-group btn-custom">
      <button class="btn btn-outline-primary" (click)="export()">
        {{ "COMMISSIONS.EXPORT" | translate }}
      </button>
    </div>
    <div class="form-group btn-custom">
      <button class="btn btn-secondary" (click)="toggleChart()">
        {{ showChart ? ("COMMISSIONS.SHOW_TABLE" | translate) : ("COMMISSIONS.SHOW_CHART" | translate) }}
      </button>
    </div>
    <div
      class="form-group btn-custom"
      *ngIf="
        clientIdSelected != 0 ||
        commissionIdSelected != 0 ||
        status != 0 ||
        !!commissionNameOrEmployeeName ||
        selectedStartMonth != 1 ||
        selectedEndMonth != currentMonth ||
        selectedStartYear != currentYear ||
        selectedEndYear != currentYear
      "
    >
      <button class="btn btn-danger" (click)="reset()">
        {{ "RESET" | translate }}
      </button>
    </div>
  </div>
  <section *ngIf="!showChart" class="mt-1">
    <div class="card px-0 pb-0">
      <ngx-datatable
        class="bootstrap core-bootstrap"
        columnMode="force"
        #table
        [headerHeight]="30"
        [scrollbarH]="true"
        [rowHeight]="_utilService.isDesktop ? 70 : 200"
        [limit]="10"
        [footerHeight]="50"
        [rows]="commissions"
        [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
      >
        <ngx-datatable-row-detail rowHeight="auto" #myDetailRow>
          <ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
            <div class="child-datatable">
              <div class="row align-items-center" *ngFor="let detail of row.commission_details; let l = last" [ngClass]="{'mb-075': !l}">
                <div class="col-lg-1 pr-0 text-right">
                    <span [ngbTooltip]="detail.user.complete_name" placement="right">
                      <i [data-feather]="'user'" class="font-medium-3 mr-1"></i>
                    </span>
                </div>
                <div class="col-lg-2 pr-0">{{ (formatMonth(detail?.month) | titlecase) + " " + detail?.year }}</div>
                <div class="col-lg-2 pl-2">{{ detail.estimate_cost | currency: "EUR" }}</div>
                <div class="col-lg-1 pl-0 mr-5">{{ detail.real_cost | currency: "EUR" }}</div>
                <div class="col-lg-2 pl-1">{{ detail.real_profit | currency: "EUR" }}</div>
                <div class="col-lg-2 pl-1 text-break-line-2">{{ detail.margin_currency | currency: "EUR" }}</div>
                <div class="col-lg-1 pl-1 text-break-line-2">{{ detail.margin_percentage }} %</div>
              </div>
            </div>
          </ng-template>
        </ngx-datatable-row-detail>
        <ngx-datatable-column *ngIf="_utilService.isDesktop" [width]="30" [resizeable]="false" [sortable]="false" [draggable]="false" [canAutoResize]="false">
          <ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
            <a href="javascript:void(0)" [class.datatable-icon-right]="!expanded" [class.datatable-icon-down]="expanded" title="Expand/Collapse Row" (click)="toggleExpandRow(row, expanded)"> </a>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column *ngIf="_utilService.isDesktop" [width]="120" [name]="'COMMISSION_NAME' | translate" prop="commission_complete_name">
          <ng-template ngx-datatable-cell-template let-row="row">
            <a class="text-break-line-2" target="_blank" [ngbTooltip]="row.commission_complete_name" *ngIf="row.commission_complete_name" [routerLink]="'/dashboard/commission/edit/' + row.commission_id">{{ row.commission_complete_name }}</a>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column *ngIf="_utilService.isDesktop" [width]="120" [name]="'ESTIMATED_COST' | translate" prop="total_estimate_cost">
          <ng-template ngx-datatable-cell-template let-row="row">
            <div class="text-break-line-2">{{ row.total_estimate_cost | currency: "EUR" : "symbol" }}</div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column *ngIf="_utilService.isDesktop" [width]="120" [name]="'ESTIMATED_REVENUE' | translate" prop="total_estimate_profit">
          <ng-template ngx-datatable-cell-template let-row="row">
            <div class="text-break-line-2">{{ row.total_estimate_profit | currency: "EUR" : "symbol" }}</div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column *ngIf="_utilService.isDesktop" [width]="120" [name]="'EFFECTIVE_COST' | translate" prop="total_real_cost">
          <ng-template ngx-datatable-cell-template let-row="row">
            <div class="text-break-line-2">{{ row.total_real_cost | currency: "EUR" : "symbol" }}</div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column *ngIf="_utilService.isDesktop" [name]="'EFFECTIVE_REVENUE' | translate" prop="total_real_profit">
          <ng-template ngx-datatable-cell-template let-row="row">
            <div class="text-break-line-2">{{ row.total_real_profit | currency: "EUR" : "symbol" }}</div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column *ngIf="_utilService.isDesktop" [width]="80" [name]="'EURO_MARGIN' | translate" prop="margin_euro">
          <ng-template ngx-datatable-cell-template let-row="row">
            <div class="text-break-line-2">{{ row.margin_euro | currency: "EUR" : "symbol" }}</div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column *ngIf="_utilService.isDesktop" [width]="80" [name]="'PERCENTAGE_MARGIN' | translate" prop="margin_percentage">
          <ng-template ngx-datatable-cell-template let-row="row">
            <div class="text-break-line-2">{{ row.margin_percentage }} %</div>
          </ng-template>
        </ngx-datatable-column>
        <!--mobile-->
        <ngx-datatable-column [name]="'NAME' | translate" prop="commission_complete_name" *ngIf="!_utilService.isDesktop">
          <ng-template ngx-datatable-cell-template let-row="row">
            <div class="row list-item-mobile">
              <div class="col-12 mb-1">
                <a class="text-break-line-2" *ngIf="row.commission_complete_name" [ngbTooltip]="row.commission_complete_name" [routerLink]="'/dashboard/commission/edit/' + row.commission_id">{{ row.commission_complete_name }}</a>
              </div>
              <div class="col-12">
                <span class="font-weight-bold">{{ "ESTIMATED_COST" | translate }}: </span>
                <span>{{ row.total_estimate_cost | currency: "EUR" : "symbol" }}</span>
              </div>
              <div class="col-12">
                <span class="font-weight-bold">{{ "EFFECTIVE_COST" | translate }}: </span>
                <span>{{ row.total_real_cost | currency: "EUR" : "symbol" }}</span>
              </div>
              <div class="col-12">
                <span class="font-weight-bold">{{ "ESTIMATED_REVENUE" | translate }}: </span>
                <span>{{ row.total_real_profit | currency: "EUR" : "symbol" }}</span>
              </div>
              <div class="col-12">
                <span class="font-weight-bold">{{ "EURO_MARGIN" | translate }}: </span>
                <span class="text-break-line-2" *ngIf="row.total_real_cost > 0">{{ (row.total_real_profit - row.total_real_cost) | currency: "EUR" : "symbol" }}</span>
                <span class="text-break-line-2" *ngIf="row.total_real_cost < 1">{{ 0 | currency: "EUR" : "symbol" }}</span>
              </div>
              <div class="col-12">
                <span class="font-weight-bold">{{ "PERCENTAGE_MARGIN" | translate }}: </span>
                <span *ngIf=" row.total_real_cost > 0">{{ _utilService.calculatePercentageBetweenTwoNumbers(row.total_real_profit, row.total_real_cost) }} %</span>
                <span *ngIf=" row.total_real_cost < 1">0 %</span>
              </div>
            </div>
          </ng-template>
        </ngx-datatable-column>
        <!--mobile-->
      </ngx-datatable>
      <div class="row">
        <div class="col-12 px-0 border-top pt-1 pb-2">
          <div class="row font-weight-bold-custom" *ngIf="_utilService.isDesktop">
            <div class="col-lg-2 pl-4">{{ "TOTAL" | translate }}</div>
            <div class="col-lg-10 pl-3" style="display: grid; grid-template-columns: repeat(6, 1fr); gap: 10px;">
              <div [ngbTooltip]="'ESTIMATED_COST' | translate">{{ sumOfEstimatedCosts | currency: "EUR" : "symbol" }}</div>
              <div [ngbTooltip]="'EFFECTIVE_COST' | translate">{{ sumOfRealCost | currency: "EUR" : "symbol" }}</div>
              <div [ngbTooltip]="'ESTIMATED_REVENUE' | translate">{{ sumOfRealProfit | currency: "EUR" : "symbol" }}</div>
              <div [ngbTooltip]="'EFFECTIVE_REVENUE' | translate">{{ sumOfRealProfit | currency: "EUR" : "symbol" }}</div>
              <div [ngbTooltip]="'EURO_MARGIN' | translate">{{ (sumOfRealProfit - sumOfRealCost) | currency: "EUR" : "symbol" }}</div>
              <div [ngbTooltip]="'PERCENTAGE_MARGIN' | translate">{{ _utilService.calculatePercentageBetweenTwoNumbers(sumOfRealProfit, sumOfRealCost) }} %</div>
            </div>
          </div>
          <!--mobile-->
          <div class="row px-2" *ngIf="!_utilService.isDesktop">
            <div class="px-1 ml-1 col-12">
              <strong>{{ "TOTAL" | translate }}</strong>
            </div>
            <div class="px-1 ml-1 col-12">
              <strong>{{ "ESTIMATED_COST" | translate }}</strong
              >:&nbsp;
              <span>{{ sumOfEstimatedCosts | currency: "EUR" : "symbol" }}</span>
            </div>
            <div class="px-1 ml-1 col-12">
              <strong>{{ "EFFECTIVE_COST" | translate }}</strong
              >:&nbsp;
              <span>{{ sumOfRealCost | currency: "EUR" : "symbol" }}</span>
            </div>
            <div class="px-1 ml-1 col-12">
              <strong>{{ "ESTIMATED_REVENUE" | translate }}</strong
              >:&nbsp;
              <span>{{ sumOfEstimateProfit | currency: "EUR" : "symbol" }}</span>
            </div>
            <div class="px-1 ml-1 col-12">
              <strong>{{ "EFFECTIVE_REVENUE" | translate }}</strong
              >:&nbsp;
              <span>{{ sumOfRealProfit | currency: "EUR" : "symbol" }}</span>
            </div>
            <div class="px-1 ml-1 col-12">
              <strong>{{ "EURO_MARGIN" | translate }}</strong
              >:&nbsp;
              <span>{{ sumOfMarginCurrency | currency: "EUR" : "symbol" }}</span>
            </div>
            <div class="px-1 ml-1 col-12">
              <strong>{{ "PERCENTAGE_MARGIN" | translate }}</strong
              >:&nbsp;
              <span>{{ averageMarginPercentage + " %" }}</span>
            </div>
          </div>
          <!--mobile-->
        </div>
      </div>
    </div>
  </section>
  <div *ngIf="showChart" class="mt-4">
    <!-- misurazione fatturato costi -->
    <div class="card card-chart">
      <h4 class="card-title">{{ "ANALYTICS.SALES_COSTS" | translate }}</h4>
      <div class="row mx-0">
        <div class="col-md-12 col-12 revenue-report-wrapper">
          <div id="revenue-report-chart">
            <apx-chart
              [series]="dataChart.series"
              [chart]="chartOptions.chart"
              [xaxis]="dataChart.xaxis"
              [stroke]="chartOptions.stroke"
              [yaxis]="chartOptions.yaxis"
              [dataLabels]="chartOptions.dataLabels"
              [tooltip]="chartOptions.tooltip"
              [legend]="chartOptions.legend"
            ></apx-chart>
          </div>
        </div>
      </div>
    </div>
    <!-- misurazione fatturato costi -->
  </div>
</div>
